import i18n from '@/i18n';

const API_URL = process.env.REACT_APP_API_URL ?? '';

// Backend tüm hataları { error: "mesaj" } olarak döner.
export class ApiError extends Error {
  status: number;
  // Hata gövdesinin tamamı (ör. 401'de { requireGoogleLogin: true } gibi ek
  // bayraklar) — çağıran taraf duruma göre davranabilsin diye saklanır.
  data: unknown;

  constructor(status: number, message: string, data: unknown = null) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

// Public site — oturum/çerez yok. İstekler kimliksiz gider (credentials: 'omit').
export async function apiFetch<T>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const isFormData = options.body instanceof FormData;
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    credentials: 'omit',
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...options.headers,
    },
  });

  const isJson = response.headers
    .get('content-type')
    ?.includes('application/json');
  const body = isJson ? await response.json() : null;

  if (!response.ok) {
    const message =
      (body as { error?: string } | null)?.error ??
      i18n.t('common.unexpectedError');
    throw new ApiError(response.status, message, body);
  }

  return body as T;
}

// Hata nesnesinden okunabilir mesaj çıkarır (form/uyarı gösterimi için).
export function getErrorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof Error) return err.message;
  return i18n.t('common.unexpectedError');
}
